module.exports = __webpack_public_path__ + "static/media/close.91ceff05.svg";